import { render, staticRenderFns } from "./FiltersMenu.vue?vue&type=template&id=3aabd3c2&"
import script from "./FiltersMenu.vue?vue&type=script&lang=ts&"
export * from "./FiltersMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports